/*
 * ez-offer.js -- behaviour for the general offer go_2609 surfaces (bar, PDP line, cart nudge,
 * pair rail). Spec: business/research/general-offer-2026-09/spec.md sections 5-6.
 * Vanilla, no dependencies, defined once (idempotency guard). Every event goes through
 * window.ezDiscountTrack (snippets/ez-discount-tracking.liquid) so it carries ez_device_id.
 *
 * Surfaces opt in with data attributes (all rendered by Liquid):
 *   [data-ez-offer][data-ez-offer-end="<epoch ms>"]   removed on load once past the end
 *                                                      (page cache can serve a stale Liquid state)
 *   [data-ez-promo-view]  + data-ez-creative-name / data-ez-creative-slot / data-ez-items (JSON)
 *                          -> view_promotion once per page view, when 50% in view
 *   [data-ez-promo-select] (a link) -> select_promotion on tap, with data-ez-item (JSON) if set
 *   [data-ez-offer-pdp] + data-ez-nets (JSON {variantId: {n,w,s,d,a}}) -> follows variant:update
 *   [data-ez-offer-cart]  + data-ez-state / -frames / -gap / -value -> ez_offer_cart_state,
 *                          ez_offer_upgrade (once per session, single -> duo)
 */
(function () {
  if (window.__ezOfferGo2609) return;
  window.__ezOfferGo2609 = true;

  var PROMO = { promotion_id: 'go_2609', promotion_name: 'general_offer_2609' };
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function track(name, params) {
    if (typeof window.ezDiscountTrack === 'function') window.ezDiscountTrack(name, params);
  }
  function parse(json) {
    try { return json ? JSON.parse(json) : null; } catch (e) { return null; }
  }
  function promoParams(el) {
    var p = { promotion_id: PROMO.promotion_id, promotion_name: PROMO.promotion_name };
    if (el) {
      p.creative_name = el.getAttribute('data-ez-creative-name') || '';
      p.creative_slot = el.getAttribute('data-ez-creative-slot') || '';
    }
    return p;
  }

  function expire() {
    var now = Date.now();
    var els = document.querySelectorAll('[data-ez-offer-end]');
    for (var i = 0; i < els.length; i++) {
      var end = parseInt(els[i].getAttribute('data-ez-offer-end'), 10);
      if (end && now >= end) els[i].parentNode && els[i].parentNode.removeChild(els[i]);
    }
  }

  function fireView(el) {
    if (seen) { if (seen.has(el)) return; seen.add(el); }
    else { if (el.__ezSeen) return; el.__ezSeen = true; }
    var p = promoParams(el);
    var items = parse(el.getAttribute('data-ez-items'));
    if (items && items.length) p.items = items;
    track('view_promotion', p);
  }

  var io = null;
  function observeViews() {
    var els = document.querySelectorAll('[data-ez-promo-view]');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) fireView(els[i]);
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { fireView(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.5 });
    }
    for (var j = 0; j < els.length; j++) {
      if (seen && seen.has(els[j])) continue;
      io.observe(els[j]);
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-ez-promo-select]') : null;
    if (!a) return;
    var host = a.closest('[data-ez-creative-name]') || a;
    var p = promoParams(host);
    var item = parse(a.getAttribute('data-ez-item'));
    if (item) p.items = [item];
    p.beacon = true; /* the tap navigates; beacon survives the unload */
    track('select_promotion', p);
  });

  /* PDP: the offer price card follows the selected variant (net, was, save, net2, sold-out).
     Map entries are {n, w, s, d, a}; a variant missing from the map hides the card, which
     brings the theme price back (CSS :has in blocks/ez-offer-pdp.liquid). */
  function setText(root, sel, val) {
    var el = root.querySelector(sel);
    if (el && val != null) el.textContent = val;
  }
  document.addEventListener('variant:update', function (e) {
    var v = e && e.detail && e.detail.resource;
    if (!v || v.id == null) return;
    var boxes = document.querySelectorAll('[data-ez-offer-pdp]');
    for (var i = 0; i < boxes.length; i++) {
      var nets = parse(boxes[i].getAttribute('data-ez-nets')) || {};
      var row = nets[String(v.id)];
      if (!row) { boxes[i].hidden = true; continue; }
      if (typeof row === 'string') row = { n: row };
      setText(boxes[i], '[data-ez-net]', row.n);
      setText(boxes[i], '[data-ez-was]', row.w);
      setText(boxes[i], '[data-ez-save]', row.s);
      setText(boxes[i], '[data-ez-net2]', row.d);
      boxes[i].classList.toggle('ez-offer-pdp--soldout', row.a === false);
      boxes[i].hidden = false;
    }
  });

  /* Cart: state event on every render, upgrade once per session. */
  var lastSig = '';
  function cartState() {
    var el = document.querySelector('[data-ez-offer-cart]');
    if (!el) return;
    var state = el.getAttribute('data-ez-state') || 'none';
    var frames = parseInt(el.getAttribute('data-ez-frames'), 10) || 0;
    var gap = parseInt(el.getAttribute('data-ez-gap'), 10) || 0;
    var value = parseFloat(el.getAttribute('data-ez-value')) || 0;
    var sig = state + '|' + frames + '|' + gap + '|' + value;
    if (sig === lastSig) return;
    lastSig = sig;
    track('ez_offer_cart_state', {
      ez_offer_id: 'go_2609', ez_offer_state: state, ez_frames_in_cart: frames,
      ez_to_free_delivery_pkr: gap, value: value, currency: 'PKR'
    });
    try {
      var ss = window.sessionStorage;
      var prev = ss.getItem('ez_go2609_state');
      if (prev === 'single' && state === 'duo' && !ss.getItem('ez_go2609_upg')) {
        ss.setItem('ez_go2609_upg', '1');
        track('ez_offer_upgrade', { ez_offer_id: 'go_2609', ez_from: 'single', ez_to: 'duo', value: value, currency: 'PKR' });
      }
      if (state !== 'none') ss.setItem('ez_go2609_state', state);
    } catch (err) {}
  }

  function run() { expire(); observeViews(); cartState(); }

  document.addEventListener('cart:update', function () {
    /* the cart section morphs right after this event; read the fresh DOM after it lands */
    window.setTimeout(run, 700);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
